export enum POST_COLLAB_DOC_CHECKPOINT_REASON {
    replace = 'replace',
    restore = 'restore',
    publish = 'publish',
    persist = 'persist',
    migration = 'migration',
}
